import {PLANET_HD_V1_ENABLED} from '../../../../config/featureFlags'
import {REMOTE_SENSING_PRODUCTS} from '../../Fields/ViewField/ViewLand/Images/remoteSensingModel'

export const getNdviReportProduct = (report = {}) => (
  report.product ||
  report.remote_sensing_source?.product ||
  null
)

export const getNdviReportSourceLabel = (report = {}) => {
  const product = getNdviReportProduct(report)
  if (!product) {
    return null
  }

  return product === REMOTE_SENSING_PRODUCTS.PLANET_SCOPE_HD
    ? 'Planet HD · NDVI'
    : 'Sentinel · NDVI'
}

export const withNdviReportProduct = (
  payload,
  product,
  {enabled = PLANET_HD_V1_ENABLED} = {}
) => (
  enabled || product === REMOTE_SENSING_PRODUCTS.PLANET_SCOPE_HD
    ? {...payload, product}
    : payload
)
